module.exports = __webpack_public_path__ + "static/media/icon_chrome.3938c625.svg";